import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';

export default {
  methods: {
    rotateLeft() {
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.ROTATE_OBJECT, -1);
      this.emitUndoRedoRequest('Object Rotate');
    },
    rotateRight() {
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.ROTATE_OBJECT, 1);
      this.emitUndoRedoRequest('Object Rotate');
    },
    flipHorizontal() {
      if (this.isMultiPropertySelection) {
        EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.FLIP_OBJECTS, 1);
        return;
      }
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.FLIP_OBJECT, 1);
    },
    flipVertical() {
      if (this.isMultiPropertySelection) {
        EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.FLIP_OBJECTS, -1);
        return;
      }
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.FLIP_OBJECT, -1);
    },
  },
};
